import { connect } from 'react-redux';
import React from 'react';
import PropTypes from 'prop-types';
import { telemetry } from './../helpers';
import { getTelemetryPageType } from './../reducers';

// Selectors
import {
} from '../reducers';

// API Actions
import {
} from './../actions';

// This is the main component for the cloud page.  Container is effectively
// glue between the state/model and the view/html
export class TelemetryContainer extends React.Component {

    static propTypes = { pageType: PropTypes.string.isRequired };

    render() {
      switch (this.props.pageType) {
        case telemetry.PROCESS:
          // eslint-disable-next-line max-len
          return <iframe width="99%" height="900px" src="https://datastudio.google.com/embed/reporting/8476fce0-6387-499d-ac89-d794d5e31502/page/fWM8" frameborder="0" style={{ 'border': 0 }} allowfullscreen />;
        case telemetry.EXAMINE:
          // eslint-disable-next-line max-len
          return <iframe width="99%" height="900px" src="https://datastudio.google.com/embed/reporting/1nckBpO6nwyjMR5QxwTL7SFZkx82P7uar/page/MxF5" frameborder="0" style={{ 'border':0 }} allowfullscreen />;
        case telemetry.AXIOM_SCANS_TODAY:
          // eslint-disable-next-line max-len
          return <iframe width="99%" height="900px" src="https://datastudio.google.com/embed/reporting/90e2e0e8-41b3-411c-926c-4d88d661a085/page/NSN8" frameborder="0" style={{ 'border':0 }} allowfullscreen />;
        case telemetry.ARTIFACT_STATS:
          // eslint-disable-next-line max-len
          return <iframe width="99%" height="900px" src="https://datastudio.google.com/embed/reporting/4001d8d4-ddab-43a0-bb4e-274bdf7a9890/page/EAP8" frameborder="0" style={{ 'border':0 }} allowfullscreen />;
        case telemetry.JIRA_METRICS:
          // eslint-disable-next-line max-len
          return <iframe width="99%" height="900px" src="https://datastudio.google.com/embed/reporting/1gCiq6H0j94XMgjZk2aBrWnhHtI7WjU57/page/tqiEB" frameborder="0" style={{ 'border':0 }} allowfullscreen />;
        default:
          return <div>default</div>;
      }
    }
}

export const mapStateToProps = (state) => {
  return { pageType: getTelemetryPageType(state) };
};

export default connect(
  mapStateToProps
)(TelemetryContainer);



// WEBPACK FOOTER //
// src/Containers/TelemetryContainer.jsx